import { useEffect, useRef } from "react";

// Outside-click + Escape para popovers/dropdowns. Devuelve un ref para el
// contenedor; mientras `open`, si el usuario clickea afuera del ref o aprieta
// Escape, dispara onDismiss. Centraliza el patron que estaba duplicado inline
// en el FontSelector y que ahora comparten FontPicker y HelpPopover.
//
// onDismiss se guarda en un ref para que el efecto NO se re-suscriba en cada
// render (callers pueden pasar una arrow inline sin memoizar).
export function useDismissable<T extends HTMLElement = HTMLDivElement>(
  open: boolean,
  onDismiss: () => void,
) {
  const ref = useRef<T>(null);
  const cb = useRef(onDismiss);
  cb.current = onDismiss;

  useEffect(() => {
    if (!open) return;
    function onPointer(e: PointerEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) cb.current();
    }
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") cb.current();
    }
    document.addEventListener("pointerdown", onPointer);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("pointerdown", onPointer);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return ref;
}
